<template>
	<v-container
		grid-list-xl
	>
		<v-layout
			row
			wrap
			align-center
			justify-center
		>
			<v-flex
				xs12
				md8
				pa-0
			>
				<slot name="alert" />
			</v-flex>
		</v-layout>
		<NewReport v-if="$userCan('create_reports') && !project.isArchived" />
		<ReportIterator
			:items="reports.models"
			@edit="setEditReport"
			@archive="archiveReport"
			@update-pagination="pagination = $event"
		/>
		<v-dialog
			v-model="editReport.show"
			max-width="800px"
		>
			<v-card v-if="editReport.show">
				<EditReport
					:edit-report="editReport.report"
					@saving-done="editReport.show = false"
					@cancel="editReport.show = false"
				/>
			</v-card>
		</v-dialog>
		<ArchivedReports v-if="$userCan('manage_reports')" />
		<Confirm ref="confirm" />
	</v-container>
</template>

<script>
import ArchivedReports from '@/components/Report/ArchivedReports';
import ReportIterator from '@/components/Report/ReportIterator';
import NewReport from '@/components/Report/NewReport';
import EditReport from '@/components/Report/EditReport';
import Confirm from '@/components/Confirm';

export default {
	components: {
		NewReport,
		EditReport,
		Confirm,
		ReportIterator,
		ArchivedReports,
	},
	data() {
		return {
			editReport: { show: false, report: null },
		};
	},
	computed: {
		project() {
			return this.$store.get('projects/currentProject');
		},
		reports() {
			return this.$store.get('reports/active');
		},
	},
	methods: {
		/**
		 * Duplicate in @/views/Dashboard.vue
		 * @todo Find a way to put it in one place
		 */
		archiveReport(report) {
			const name = report.displayName;

			this.$refs.confirm.createConfirm(`This will archive "${name}".`, 'error')
				.then((answer) => {
					if (!answer) {
						return;
					}

					report.isArchived = true;
					report.save().then(() => {
						this.$store.dispatch('reports/archive', report);
						this.$notify('success', `Report "${name}" has been archived.`);
					}).catch((e) => {
						dump('Error archiving report', e);
						this.$notify('error', `Failed to archive report "${name}".`);
					});
				});
		},
		setEditReport(report) {
			this.editReport.report = report;
			this.editReport.show = true;
		},
	},
};
</script>
